import type { components } from './tipos/plataforma';

type IdNegocio = components['schemas']['BusinessId'];

/** Ruta de un negocio: `/v1/businesses/{business_id}`. */
export const negocio = (id: IdNegocio): `/v1/${string}` => `/v1/businesses/${encodeURIComponent(id)}`;

/** Parámetros de consulta (`?a=1&b=2`), sin los que no tienen valor. Vacío si no hay ninguno. */
export function consulta(parametros: Record<string, string | number | boolean | null | undefined | readonly (string | number)[]>): string {
    const p = new URLSearchParams();
    for (const [clave, valor] of Object.entries(parametros)) {
        // Una lista va separada por comas (`style: form`, `explode: false`; `status=draft,published`, G827).
        const texto = Array.isArray(valor) ? valor.join(',') : valor;
        if (texto !== undefined && texto !== null && texto !== '') {
            p.set(clave, String(texto));
        }
    }
    const texto = p.toString();
    return texto === '' ? '' : `?${texto}`;
}

/** Página de una lista con cursor (G121): «Anterior / Siguiente» sin total. */
export interface Pagina {
    cursor?: string | null;
    limit?: number;
}

/**
 * Clave de idempotencia nueva para las operaciones que la admiten (`x-idempotent`). Cada operación que la lleva acepta
 * también una clave ya hecha (`clave`): así se puede **repetir la misma petición con la misma clave**, por ejemplo tras
 * confirmar los dos pasos en el momento (G116, `conDosPasosEnElMomento`).
 */
export function claveIdempotencia(): string {
    return globalThis.crypto.randomUUID();
}
